import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { finalize } from 'rxjs/operators';
import { AuthenticationSelectors } from '../auth/state/authentication.selectors';
import { User } from '../core/model/user.model';
import { TicketModel } from './types/ticket.model';
import { SupportService } from './service/support.service';

@Component({
  selector: 'support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})

export class SupportComponent {
  currentUser$: Observable<User>;
  loading: boolean;

  constructor(private authencationSelectors: AuthenticationSelectors, private supportService: SupportService) {
    this.currentUser$ = authencationSelectors.selectCurrentUser();
  }

  sendData(ticket: TicketModel): void {
    this.startLoading();
    this.supportService.sendMessage(ticket)
                        .pipe(finalize(() => this.stopLoading()))
                        .subscribe();
  }

  private startLoading(): void {
    this.loading = true;
  }

  private stopLoading(): void {
    this.loading = false;
  }
}
